<template>
    <div>
        <header class="auth-layout__header">
            <router-link :to="{ name: RoutesEnum.INDEX.HOME }" class="auth-layout__logo">
                <common-icon name="logo" size="extra-large"></common-icon>
            </router-link>
        </header>

        <common-page-header :heading="$t('pages.auth.login.activating')" size="large" :isCenter="true"></common-page-header>
    </div>
</template>

<script>
    import AuthAPI from 'api/AuthAPI'
    import RoutesEnum from 'enums/routes.enum'
    import LoginType from 'enums/login_type.enum'
    export default {
        data: () => ({ RoutesEnum }),

        mounted() {
            this.$startLoader()
            const { token: accessToken } = this.$route.query
            AuthAPI.verifyEmail({ accessToken })
                .then((response) => {
                    this.$auth.createSession({
                        accessToken: response.payload.access_token,
                        refreshToken: response.payload.refresh_token,
                        loginType: LoginType.BASIC,
                    })
                    this.$router.push({ name: RoutesEnum.INDEX.HOME, query: { verify: 'success' } })
                })
                .catch((error) => {
                    this.$router.push({
                        name: RoutesEnum.AUTH.LOGIN,
                        query: {
                            text: this.$t(`${error?.error?.message?.split('.')[1]?.toLowerCase()}`) || 'error',
                            type: 'error',
                        },
                    })
                })
                .finally(() => this.$stopLoader())
        },
    }
</script>
